import { 
    ErrorCode,
    PaymentStatus
} from './statusCode';
import { PrestoAppTheme } from 'presto-mini-apps-lib';

const term_GooglePlay = 'Google Play';
const term_AppStore = 'App Store';
const term_AppGallery = 'AppGallery';
const term_details = 'Details';
const term_item = 'Items';
const term_login = 'Login';
const term_change = 'Change';
const term_ok = 'OK';
const term_continue = 'Continue';
const term_paymentAmount = 'Payment Amount';
const term_onlinebanking = 'Online Banking';
const phrase_return = (name) => `Return to ${name}`;
const term_select_other_login_methods = 'Or select other log in methods';
const term_select_login_method = 'Select Log In Method';

const title_qrScanPay = 'Scan QR To Pay';
const title_loginPay = 'Login to Pay';
const title_transactionPin = 'Transaction PIN';
const title_otpNumber = 'SMS (OTP)';

const phrase_QRScanInstruction = 'Scan QR Code to Pay';
const phrase_QRScanSteps = [
    'Open your Presto App',
    'Go to Wallet > Scan',
    'Scan This Code'
];

const phrase_VerifyingPayment = 'Verifying Payment';


// FORM input
const term_email = 'Email';
const phrase_EmailPlaceholderText = 'Enter email';
const term_mobile = 'Mobile';
const phrase_MobilePlaceholderText = 'Enter mobile number';
const phrase_MobilePreText = '+60';
const phrase_MobileErrorMessage = 'Username and Password do not match';
const phrase_OTPMobileErrorMessage = 'Invalid OTP';
const phrase_OTPLoginErrorMessage = 'Username and SMS OTP do not match';
const phrase_PINLoginErrorMessage = 'Username and Transaction PIN do not match';
const phrase_EmailErrorMessage = 'Oops, email invalid, please try again and enter your registered email.';
const term_password = 'Password';
const phrase_PasswordPlaceholderText = 'Enter your password';
const phrase_PasswordErrorMessage = 'Oops, password invalid, please try again and enter your correct password.';
const phrase_PasswordErrorPolicyMismatch = `We've enhanced our password policy. Please change your password on your mobile before you log in again.`;
const phrase_DefaultError = 'Invalid input';
const term_confirmPayment = 'Confirm Payment';
const term_confirm = 'Confirm';

const term_transaction_pin = 'Transaction PIN';
const phrase_PINPlaceholderText = 'Enter 6-digit PIN';
const phrase_PINErrorMessage = 'Incorrect Transaction PIN. Please try again and enter the correct 6-digit Transaction PIN.';

const term_otp = 'SMS OTP';
const phrase_OTPPlaceholderText = 'Enter 6 digit OTP';
const phrase_OTPErrorMessage = 'Incorrect SMS OTP. Please try again and enter your correct OTP number received.';
const phrase_OTPTimer = 'Resend ';
const term_resendOTP = `Resend OTP`;
const term_getOTP = `Get OTP`;

const title_selectedPayment = `Selected Payments`;
const term_totalAmount = `Total Amount`;

const phrase_CancelTransaction = 'Return to Merchant';
const phrase_CancelTransactionAndReturn = `Cancel and ${phrase_CancelTransaction}`;

const phrase_InsufficientBalance = {
    /* 
    hasOtherPayments: {
        message: (paymentType) => `Oops, Your ${paymentType} is out of balance. Please pay the remaining balance with other payment method below or `,
        returnTo: phrase_CancelTransaction,
    },
    noOtherPayments: {
        message: (paymentType) => `Oops, Your ${paymentType} is out of balance. Please top up your PrestoPay in Presto App and `,
        returnTo: 'Return back to Merchant',
    }, 
    */
    hasOtherPayments: {
        title: 'Not enough balance',
        message: (remainingAmount) => `Select a method below to pay the remaining ${remainingAmount} or change payment method.`,
    },
    noOtherPayments: {
        title: 'Not enough balance',
        message: (remainingAmount) => `Please top up your PrestoPay in Presto App to pay the remaining ${remainingAmount}.`,
    },
};


// Result
const title_success = 'Payment Successful';
const phrase_SuccessText = (amountStr, merchantName) => `Your payment of <strong style='color:${PrestoAppTheme.colors.prestoRed}'>${amountStr}</strong> was received by <strong>${merchantName}</strong>. Thank You!`;
const term_amount = 'Amount';
const term_merchant = 'Merchant';
const term_payWith = 'Pay With';
const term_useLoyaltyPoints = 'Use Loyalty Points';
const term_loyaltyDisclaimerLine = 'Terms and Conditions apply. For more information, see Presto’s <a target="_blank" href="https://www.prestouniverse.com/my/terms-of-use">Terms of Use</a>.';
const term_refNum = 'Ref No.';
const term_date = 'Date';
const term_cardDisplayName = 'Display Name';
const term_return = 'Go Back';
const term_points = 'points';
const term_topUp = 'Top Up';
const term_topUpCredits = 'Credits Top Up';
const term_topUpUsing = 'Top Up Using';
const term_topUpMinimum = 'Minimum top up amount is ';
const phrase_continue = (merchant) => `Continue to ${merchant}`;
const title_topUpSuccess = 'Top Up Successful!';
const phrase_topUpSuccessText = (amountStr) => `You've succesfully topped up</br> <strong style='color:${PrestoAppTheme.colors.prestoRed}'>${amountStr}</strong> to your Credits.`;
const phrase_PINNotNotMatch = 'New PIN and re-enter new PIN does not match.';


// Error Messages
const ErrorMessages = {
    [PaymentStatus.CANCELLED] : {
        title: 'Payment Cancelled',
        message : 'Opps! Looks like you have cancelled your payment.',
    },
    [PaymentStatus.EXPIRED] : {
        title: 'Payment Expired',
        message : 'Opps! Looks like your payment has expired. Please try again.',
    },
    [PaymentStatus.FAILED] : {
        title: 'Payment Failed',
        message : 'Opps! Looks like your payment has failed. Please try again.',
    },
    [PaymentStatus.LIMIT_REACHED] : {
        title: 'Payment Limit Reached',
        message : 'Opps! Looks like you have reached your<br />web payment limit. Please try again.',
    },
    QRRegistered: {
        title: 'QR Scan Successful',
        message: 'You may continue the payment<br />via Presto App.',
    },
    SessionEnded: {
        title: 'Session Timeout',
        message: "Opps! Your session has expired.<br />You will be redirected to merchant's page.",
    },
    MaxLoginTriesReached: {
        title: 'Maximum Login Limit Reached',
        message: 'Opps! Looks like you have reached your login tries limit.',
    },
    Max2FAOTPTriesReached: {
        title: 'Maximum OTP Limit Reached',
        message: 'Opps! Looks like you have reached your OTP tries limit.',
    },
    Max2FAPinTriesReached: {
        title: 'Maximum Transaction PIN Limit Reached',
        message: 'Opps! Looks like you have reached your transaction PIN tries limit.',
    },
    MaxResendOTPReached: {
        title: 'OTP Resend Limit Reached',
        message: 'Opps! Looks like you have reached<br />the maximum OTP resend limit.',
    },
    DefaultError: {
        title: 'Transaction Error',
        message: "Sorry, things don't appear to be working<br />at the moment. Please try again.",
    },
    DuplicatedLogin: {
        title: 'Payment Cancelled',
        message: "Oops! Looks like you have logged in to the same transaction or refreshed the payment screen. You will be redirected to our merchant's page.",
    },
    [ErrorCode.HTTP_NOT_FOUND]: {
        title: 'Route Not Found!', 
        message: "Sorry. We couldn't find the page you were looking for.",
    },
};

const TopUpMessages = {
    [PaymentStatus.CANCELLED] : {
        title: 'Top Up Cancelled',
        message : 'Opps! Looks like you have cancelled your payment.',
    },
    [PaymentStatus.EXPIRED] : {
        title: 'Top Up Expired',
        message : 'Opps! Looks like your payment has expired.',
    },
    [PaymentStatus.FAILED] : {
        title: 'Top Up Failed',
        message : 'Credits top up failed, please try again.',
    },
    [PaymentStatus.LIMIT_REACHED] : {
        title: 'Top Up Payment Limit Reached',
        message : 'Opps! Looks like you have reached your web payment limit.',
    },
    InvalidStatus: {
        title: 'Top Up Invalid Status',
        message: "Opps! Looks like you have invalid status payment.",
    },
    DefaultError: {
        title: 'Top Up Error',
        message: "Sorry, things don't appear to be working at the moment. Please try again later.",
    },
}

const AppMessages = {
    LeavePageConfirmation: 'You may have unsaved changes. Are you sure you want to leave?', 
}

const term_addLoyalty = 'Add Loyalty Points';
const term_loyaltyBalance = (unit) => `Current ${unit}`;
const term_loyaltyValue = 'Equivalent Amount';
const term_loyaltyPoints = 'Points';
const term_loyaltyInput = 'Enter Payment Amount';
const term_loyaltyMinimum = 'The minimum payment amount is ';
const term_loyaltyMaximum = 'The maximum payment amount is ';
const term_loyaltyButtonNegative = 'Remove';
const term_loyaltyButtonPositive = 'Select';
const term_loyaltyAccount = "Account No.";
const term_loyaltyPin = 'PIN';
const term_loyaltyButtonConfirm = 'Confirm';
const term_loyaltyOtp = 'SMS OTP';
const term_loyaltyInfoTnG = 'Payment must be made with TNG eWallet when you redeem with GOrewards points.';

const phrase_LoyaltyAmountErrorMessage = 'Invalid payment amount.';
const phrase_LoyaltyAmountErrorMessage2 = 'Cannot leave less than RM1.00.';
const phrase_LoyaltyInputPin = 'Input your PIN number to retrieve your current balance.';
const phrase_LoyaltyPinErrorMessage = 'PIN invalid, please try again.';
const phrase_LoyaltyInputOtp = 'Input your SMS OTP to proceed.';
const phrase_LoyaltyOtpErrorMessage = 'SMS OTP invalid, please try again.';
const phrase_LoyaltySupplementaryTitle = 'Payment Method Unavailable';
const phrase_LoyaltySupplementaryMessage = 'We may have encountered an issue, or you may have linked a supplementary BonusLink card (only primary cards can be used for payment).<br /><br />Please try again later.';
const phrase_LoyaltyInsufficentAmountTitle = 'Insufficient Payment Amount';
const phrase_LoyaltyInsufficentAmountMessage  = (amountStr) => `Your remaining payment amount is less than the minimum amount required for this payment method (RM${amountStr}).<br/><br/>Please use another payment method or reduce the amount you selected for other loyalty payment methods.`;
const phrase_NoPaymentMethodAvailableTitle = 'No Payment Methods Unavailable';
const phrase_NoPaymentMethodAvailableMessage = 'Sorry, there are no payment methods available for this transaction on your account.<br/><br/>Please contact us for further assistance.';
const phrase_LoyaltySufficentAmountTitle = 'Sufficient Loyalty Points Selected';
const phrase_LoyaltySufficentAmountMessage = 'The loyalty points you selected are sufficient for payment. Please remove or edit your previous selection to change or add other loyalty payment method(s).';
const phrase_LoyaltyLimitReachTitle = 'Transaction Limit Reached';
const phrase_LoyaltyLimitReachMessage = (type) => `You have exceeded the ${type} transaction limit for this payment method. Please try again later or contact us for further assistance.`;
const phrase_goRewardSeclected = 'Payment with TNG eWallet Required';
const phrase_goRewardCombinationMessage = 'GOrewards points can only be</br>used with TNG eWallet.</br></br>To choose another payment method, please remove GOrewards points first.';

export {
    term_GooglePlay,
    term_AppStore,
    term_AppGallery,

    title_qrScanPay,
    title_loginPay,
    title_transactionPin,
    title_otpNumber,

    term_details,
    term_item,
    term_paymentAmount,
    term_login,
    term_change,
    term_ok,
    term_continue,
    term_confirmPayment,
    term_confirm,
    term_return,
    term_points,
    phrase_return,
    term_select_other_login_methods,
    term_select_login_method,
    term_topUp,
    term_topUpCredits,
    term_topUpUsing,
    term_topUpMinimum,

    phrase_VerifyingPayment,
    phrase_QRScanInstruction,
    phrase_QRScanSteps,

    term_mobile,
    term_email,
    term_password,
    term_transaction_pin,
    phrase_EmailPlaceholderText,
    phrase_EmailErrorMessage,
    phrase_MobilePlaceholderText,
    phrase_MobilePreText,
    phrase_MobileErrorMessage,
    phrase_OTPMobileErrorMessage,
    phrase_OTPLoginErrorMessage,
    phrase_PINLoginErrorMessage,
    phrase_PasswordPlaceholderText,
    phrase_PasswordErrorMessage,
    phrase_PasswordErrorPolicyMismatch,
    phrase_DefaultError,

    phrase_PINPlaceholderText,
    phrase_PINErrorMessage,
    phrase_InsufficientBalance,
    phrase_CancelTransaction,
    phrase_CancelTransactionAndReturn,

    term_otp,
    phrase_OTPPlaceholderText,
    phrase_OTPErrorMessage,
    phrase_OTPTimer,
    term_resendOTP,
    term_getOTP,
    title_selectedPayment,
    term_totalAmount,

    title_success,
    phrase_SuccessText,
    term_amount,
    term_merchant,
    term_payWith,
    term_useLoyaltyPoints,
    term_loyaltyDisclaimerLine,
    term_refNum,
    term_date,
    term_cardDisplayName,
    term_onlinebanking,
    phrase_continue,
    title_topUpSuccess,
    phrase_topUpSuccessText,
    phrase_PINNotNotMatch,

    ErrorMessages,
    AppMessages,
    TopUpMessages,

    term_addLoyalty,
    term_loyaltyBalance,
    term_loyaltyValue,
    term_loyaltyPoints,
    term_loyaltyInput,
    term_loyaltyMinimum,
    term_loyaltyMaximum,
    phrase_LoyaltyAmountErrorMessage,
    phrase_LoyaltyAmountErrorMessage2,
    term_loyaltyButtonNegative,
    term_loyaltyButtonPositive,
    term_loyaltyAccount,
    phrase_LoyaltyInputPin,
    phrase_LoyaltyInputOtp,
    term_loyaltyPin,
    term_loyaltyOtp,
    term_loyaltyInfoTnG,
    term_loyaltyButtonConfirm,
    phrase_LoyaltyPinErrorMessage,
    phrase_LoyaltySupplementaryTitle,
    phrase_LoyaltySupplementaryMessage,
    phrase_LoyaltyInsufficentAmountTitle,
    phrase_LoyaltyInsufficentAmountMessage,
    phrase_NoPaymentMethodAvailableTitle,
    phrase_NoPaymentMethodAvailableMessage,
    phrase_LoyaltySufficentAmountTitle,
    phrase_LoyaltySufficentAmountMessage,
    phrase_LoyaltyLimitReachTitle,
    phrase_LoyaltyLimitReachMessage,
    phrase_LoyaltyOtpErrorMessage,
    phrase_goRewardSeclected,
    phrase_goRewardCombinationMessage,
}